import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Breadcrumbs from '../../components/Admin/Breadcrumbs';
import { Briefcase, DollarSign, Receipt } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Clientes from './Clientes';
import Vendas from './Vendas';
import Pagamentos from './Pagamentos';
import { Tabs } from '../../components/UI';

const TABS = [
  { id: 'clientes', icon: Briefcase },
  { id: 'vendas', icon: DollarSign },
  { id: 'pagamentos', icon: Receipt },
] as const;

type TabId = typeof TABS[number]['id'];

const CRM: React.FC = () => {
  const { t } = useTranslation();
  const { tab } = useParams<{ tab?: string }>();

  if (!tab || !TABS.some((item) => item.id === tab)) {
    return <Navigate to="/admin/crm/clientes" replace />;
  }

  const activeTab = tab as TabId;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="mb-4">
            <Breadcrumbs />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{t('admin.crm')}</h1>
            <p className="text-gray-600">{t('admin.crmDesc')}</p>
          </div>
          <Tabs
            className="mt-6"
            ariaLabel={t('admin.crm')}
            value={activeTab}
            items={TABS.map(({ id, icon }) => ({ id, icon, label: t(`admin.${id}`), to: `/admin/crm/${id}` }))}
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        {activeTab === 'clientes' && <Clientes embedded />}
        {activeTab === 'vendas' && <Vendas embedded />}
        {activeTab === 'pagamentos' && <Pagamentos embedded />}
      </div>
    </div>
  );
};

export default CRM;
